interface IDadataOptions {
  innField?: JQuery,
  nameField?: JQuery,
}

export class LeadsOrgService {
  private options: IDadataOptions
  private selectedOrganization: IDadataResponseNode<IParty>

  constructor(options: IDadataOptions) {
    this.options = options
  }

  public successCallback(organization: IDadataResponseNode<IParty>): void {
    this.selectedOrganization = organization
    this.renderOrganizationInfo(this.selectedOrganization)
  }

  public renderOrganizationInfo(organization: IDadataResponseNode<IParty>): void {
    const {
      innField,
      nameField } = this.options

    // название организации
    if (nameField) {
      nameField.val(organization.data.name.full_with_opf)
    }

    // инн организации
    if (innField) {
      innField.val(organization.data.inn)
    }
  }
}
